"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TableRows = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var types = _interopRequireWildcard(require("../../constants"));

var _styles = require("@mui/styles");

var _DefaultRow = _interopRequireDefault(require("./DefaultRow"));

var _SkeletonRows = _interopRequireDefault(require("./SkeletonRows"));

var _RowMenu = _interopRequireDefault(require("./RowMenu"));

var _helper = require("../../helper");

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    selectedRow: {
      backgroundColor: theme.palette.row.selected,
      //lighten(theme.palette.primary.main, 0.6),
      '&:hover': {
        backgroundColor: theme.palette.row.hover //lighten(theme.palette.primary.main, 0.8),

      }
    },
    tableRow: {
      '&:nth-child(even)': {
        backgroundColor: theme.palette.row.trim //theme.palette.primary.light,

      },
      '&:hover': {
        backgroundColor: theme.palette.row.hover //lighten(theme.palette.primary.main, 0.8),

      }
    }
  };
};

var TableRows = /*#__PURE__*/function (_Component) {
  _inherits(TableRows, _Component);

  var _super = _createSuper(TableRows);

  function TableRows() {
    _classCallCheck(this, TableRows);

    return _super.apply(this, arguments);
  }

  _createClass(TableRows, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          CustomRow = _this$props.CustomRow,
          CustomRowProps = _this$props.CustomRowProps,
          loading = _this$props.loading,
          onRowClick = _this$props.onRowClick,
          _this$props$tableData = _this$props.tableData,
          rowData = _this$props$tableData.rowData,
          idKey = _this$props$tableData.idKey,
          paginate = _this$props$tableData.paginate,
          emptyMessage = _this$props$tableData.emptyMessage,
          _this$props$tableData2 = _this$props$tableData.tableSettings,
          pageIndex = _this$props$tableData2.pageIndex,
          rowsPerPage = _this$props$tableData2.rowsPerPage;
      var paginatedRows = (0, _lodash.cloneDeep)(rowData).filter(function (row) {
        return row.filtered;
      });

      if (rowsPerPage > 0 && paginatedRows.length > 10) {
        // if user selects All option, rowsPerPage value should be -1.
        var startIndex = pageIndex * rowsPerPage;
        paginatedRows = paginate ? paginatedRows.slice(startIndex, startIndex + rowsPerPage) : paginatedRows;
      }

      var tableRows = paginatedRows.map(function (row) {
        return /*#__PURE__*/_react["default"].createElement(CustomRow // defaults as DefaultRow unless a CustomRow prop is provided
        , {
          key: row[idKey],
          CustomRowProps: CustomRowProps,
          dataFormat: _helper.dataFormat,
          defaultRowClasses: classes,
          idKey: idKey,
          onRowClick: onRowClick,
          row: row,
          RowMenu: _RowMenu["default"],
          tableActions: _this.props.tableActions,
          tableData: _this.props.tableData,
          types: types
        });
      });
      var nonDataRow = null;

      if (loading) {
        nonDataRow = /*#__PURE__*/_react["default"].createElement(_SkeletonRows["default"], {
          defaultRowClasses: classes,
          tableActions: this.props.tableActions,
          tableData: this.props.tableData
        });
      } else if (!loading && paginatedRows.length === 0) {
        nonDataRow = /*#__PURE__*/_react["default"].createElement("tr", {
          id: "TableRows_nonDataRow"
        }, /*#__PURE__*/_react["default"].createElement("td", {
          colSpan: 99
        }, rowData.length > 0 ? 'No search results.' : emptyMessage));
      }

      return /*#__PURE__*/_react["default"].createElement("tbody", null, nonDataRow || tableRows);
    }
  }]);

  return TableRows;
}(_react.Component);

exports.TableRows = TableRows;

_defineProperty(TableRows, "propTypes", {
  classes: _propTypes["default"].object.isRequired,
  CustomRow: _propTypes["default"].elementType.isRequired,
  // defaults as DefaultRow but will use provided row component otherwise
  CustomRowProps: _propTypes["default"].object,
  // props that can be passed down to CustomRow
  onRowClick: _propTypes["default"].func,
  // func that can be provided that will trigger on clicking anywhere in a table row, provides row as argument
  // from TableContainer
  loading: _propTypes["default"].bool.isRequired,
  tableActions: _propTypes["default"].shape({
    actionsByTypeGet: _propTypes["default"].func.isRequired,
    updateTableState: _propTypes["default"].func.isRequired,
    getVisibleColumns: _propTypes["default"].func.isRequired
  }),
  tableData: _propTypes["default"].shape({
    columns: _propTypes["default"].array.isRequired,
    emptyMessage: _propTypes["default"].string,
    idKey: _propTypes["default"].string.isRequired,
    paginate: _propTypes["default"].bool,
    rowData: _propTypes["default"].array.isRequired,
    selectEnabled: _propTypes["default"].bool,
    statusOptions: _propTypes["default"].array,
    tableSettings: _propTypes["default"].shape({
      pageIndex: _propTypes["default"].number,
      rowsPerPage: _propTypes["default"].number
    }).isRequired
  })
});

TableRows.defaultProps = {
  CustomRow: _DefaultRow["default"]
};

var _default = (0, _styles.withStyles)(styles)(TableRows);

exports["default"] = _default;